import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';

import '../css/BalanceByAccount.css';
import '../css/MemberSite.css';

class SavingsComponent extends Component{
    productFum = {
        SLLP: 0.00,                                     //SuperLife Legacy Plan
        SLKS: 0.00,                                     //SuperLife KiwiSaver
        SLUK: 0.00,                                     //UK Pension
    }
    constructor(props){
        super(props)
        this.handleProductFum(props)
    }

    componentDidUpdate(){
        this.handleProductFum(this.props)
    }

    handleProductFum(props){
        if(props.member){
            const products = props.member.products;
            if(products.length === 1){
                const product = products[0];
                if(product.scheme === "SLI" || product.scheme === "SLWS"){
                    this.productFum ={
                        SLLP: Number(product.fum),
                        SLKS: 0.00,
                        SLUK: 0.00,
                    } 
               }
                else if(product.scheme === "SLKS"){
                    this.productFum = {
                        SLLP: 0.00,
                        SLKS: Number(product.fum),
                        SLUK: 0.00,
                    }
                }
                else if(product.scheme === "SLUK"){
                    this.productFum = {
                        SLLP: 0.00,
                        SLKS: 0.00,
                        SLUK: Number(product.fum),
                    }
                }
            }
            else if(props.member.products.length === 2){
                const product1 = products[0];
                const product2 = products[1];
                const productSchemes = []
                productSchemes.push(product1.scheme, product2.scheme)
                if(productSchemes.includes("SLI") && productSchemes.includes("SLKS")){
                    if((product1.scheme === "SLI" || product1.scheme === "SLWS") && product2.scheme === "SLKS"){
                        this.productFum = {
                            SLLP: Number(product1.fum),
                            SLKS: Number(product2.fum),
                            SLUK: 0.00
                        }
                    }
                    else if(product1.scheme === "SLKS" && (product2.scheme === "SLI" || product2.scheme === "SLWS")){
                        this.productFum = {
                            SLLP: Number(product2.fum),
                            SLKS: Number(product1.fum),
                            SLUK: 0.00
                        }
                    }
                }
            }
        }
        this.productFum.total = parseFloat(this.productFum.SLLP + this.productFum.SLKS + this.productFum.SLUK).toFixed(2)
    }

    render(){
        const {t} = this.props
        return(
            <div>
                <h1 className="balanceByAccount">{t('memberSite:balanceByAccount')}</h1>
                <span className="balanceByAccount">Member Name: {this.props.member.firstName} {this.props.member.lastName}</span> <br/>
                {this.props.member.memberNumber ? <span className="balanceByAccount">Member Number: {this.props.member.memberNumber} - </span>:<></>}
                <span className="balanceByAccount">IRD Number: {this.props.member.irdNumber}</span>
                <h3 className="balanceByAccount" >{t('balanceByAccount:savings')}</h3>
                <div className="calcsDiv">
                    <table className=" table-responsive layout fullwidth" style={{marginLeft: "12px", width: "100%"}}>
                        <tbody>
                            <tr className="whitebg"> 
                                {
                                    this.productFum.SLLP!==0.00 ? 
                                        <td className="moon">
                                            <div style={{color: "#50833C"}}>
                                                <CurrencyFormat  value={Number(this.productFum.SLLP).toFixed(2)}
                                                    displayType={'text'} 
                                                    thousandSeparator={true} 
                                                    prefix={'$'}/>
                                            </div>
                                            <div className="undermoon">{t('adviserHomePage:superlife')}</div></td> : 
                                                this.productFum.SLUK!==0.00 ? 
                                                <td className="moon" style={{textAlign: "center"}}>
                                                    <div style={{color: "#50833C"}}>
                                                        <CurrencyFormat  value={Number(this.productFum.SLUK).toFixed(2)}
                                                            displayType={'text'} 
                                                            thousandSeparator={true} 
                                                            prefix={'$'}/>
                                                    </div>
                                                    <div className="undermoon">{t('adviserHomePage:ukPension')}</div>
                                                </td> : 
                                                <td className="moon" style={{textAlign: "center"}}>
                                                    <div style={{color: "#50833C"}}>0.00</div>
                                                    <div className="undermoon">{t('adviserHomePage:superlife')}</div>
                                                </td>
                                }
                                <td rowSpan="2" className="moonconnector">+</td>
                                <td className="moon" style={{textAlign: "center"}}>
                                    <div style={{color: "#50833C"}}>
                                        <CurrencyFormat  value={Number(this.productFum.SLKS).toFixed(2)}
                                            displayType={'text'} 
                                            thousandSeparator={true} 
                                            prefix={'$'}/>
                                    </div>
                                    <div className="undermoon">{t('adviserHomePage:kiwiSaver')}</div>
                                </td>
                                <td rowSpan="2" className="moonconnector">=</td>
                                <td className="moon" style={{textAlign: "center"}}>
                                    <div style={{color: "#50833C"}}>                                        
                                    <CurrencyFormat  value={Number(this.productFum.total).toFixed(2)}
                                            displayType={'text'} 
                                            thousandSeparator={true} 
                                            prefix={'$'}/></div>
                                    <div className="undermoon">{t('adviserHomePage:total')}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default withTranslation()(SavingsComponent);